<template>
  <section>
    <form @submit.prevent="changePassword()" novalidate>
      <div class="pda-default">
        <div class="t-headline5">{{$t('1760')}}</div>
        <div class="t-body3 mgt-6 t-color-content1">{{$t('1761')}}</div>
      </div>
      <div class="pda-default mgt-4">
          <VuePhoneNumberInput
            v-model="phoneNoConfirm"
            @update="result = JSON.stringify($event)"
            :no-flags="false"
            show-code-on-list
            :translations='{ "countrySelectorLabel": countryCode,"phoneNumberLabel": phoneNoTrans}'
            :theme="theme"
            class="input-phone-number"
            @input="checkValidation"
          />
       
        <div class="t-helper t-color-red1 mgl-7 mgr-7 pdt-2 min-h-23 t-color-red1">
            <span v-show="submitState === false && inputTextVal">{{$t('1925')}}</span>
          </div> 
        <div class>
          <!-- <div class="mdc-select mdc-select--outlined w-full mgt-15" id="selectDuty">
            <i class="mdc-select__dropdown-icon select-icon-custom"></i>
            <select class="mdc-select__native-control">

              <option
                :value="data.dial_code"
                v-for="(data,i) in myJson"
                v-bind:key="i"
              >{{data.dial_code}}</option>
            </select>
            <div class="mdc-notched-outline">
              <div class="mdc-notched-outline__leading"></div>
              <div class="mdc-notched-outline__notch">
              </div>
              <div class="mdc-notched-outline__trailing"></div>
            </div>
          </div> -->
          <!-- <div class="t-helper mgl-7 mgr-7 pdt-2 min-h-23" :class="submitState && newPasswordInvalidCheck ? 't-color-red1' : ''"> -->
          <!-- <span>
                        {{$t('333')}}
                        
          </span>-->
          <!-- </div> -->

          <!-- <div
            class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full mgt-15"
            :class="submitState && phoneNoConfirmInvalidCheck ? 'mdc-text-field--invalid' : ''"
            id="phoneNoConfirmEl"
          >
            <i class="material-icons mdc-text-field__icon">{{newPasswordValidIcon}}</i>
            <input
              type="number"
              class="mdc-text-field__input"
              v-model="phoneNoConfirm"
              v-validate="'required|numeric|min:3'"
              ref="phoneNoConfirm"
              id="phoneNoConfirm"
              name="phoneNoConfirm"
              maxlength="30"
              @keypress="validatePhoneNo"
            />
            <div class="mdc-notched-outline">
              <div class="mdc-notched-outline__leading"></div>
              <div class="mdc-notched-outline__notch">
                <label for="tf-outlined" class="mdc-floating-label">{{$t('1762')}}</label>
              </div>
              <div class="mdc-notched-outline__trailing"></div>
            </div>
          </div>
          <div class="t-helper t-color-red1 mgl-7 mgr-7 pdt-2 min-h-23 t-color-red1">
            <span v-show="submitState && phoneNoConfirmInvalidCheck">{{$t('1925')}}</span>
          </div> -->

          <!-- <div class="t-helper mgl-7 mgr-7 pdt-2 min-h-23 t-color-red1">
                    <span v-show="submitState && phoneNoConfirmInvalidCheck"></span>
          </div>-->
        </div>

        <div class="mgt-40">
          <button class="mdc-button mdc-button--raised btn-red mr8" :disabled="checkDisabled">{{$t('1763')}}</button>
          <button
            class="mdc-button btn-white mgr-8 mgl-8"
            @click="cancel()"
            type="button"
          >{{$t('1764')}}</button>
        </div>
      </div>
    </form>
  </section>
</template>

<script>
import { MDCSelect } from "@material/select";
import { MDCTextField } from "@material/textfield";
import { MDCRipple } from "@material/ripple";
import memberApi from "@/api/memberApi.js";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";

export default {
  props: {
    color: { type: String, default: 'red' },
    noFlags: { type: Boolean, default: true },
    required: { type: Boolean, default: true },
    noValidatorState: { type: Boolean, default: true },
    error: { type: Boolean, default: true },
    validColor: { type: String, default: 'green' },
    errorColor: { type: String, default: 'red' },
   },
  data() {
    return {
      phoneNoConfirm: "",
      phoneNoTextField: null,
      submitState: '',
      newPasswordValidIcon: "",
      result: null,
      inputTextVal:'',
      personalInfo : null,
      profileImage:null,
      checkDisabled: true,
      phoneNoTrans:this.$t('1762'),
      countryCode:this.$t('1941')
    };
  },
  components: { VuePhoneNumberInput },
  computed: {
    phoneNoConfirmInvalidCheck() {
      let returnValue = false;
      if (this.submitState) {
        if (this.errors.has("phoneNoConfirm")) {
          returnValue = true;
          this.newPasswordValidIcon = "warning";
        } else {
          returnValue = false;
          this.newPasswordValidIcon = "check";
        }
      }
      this.phoneNoTextField.valid === !returnValue
        ? ""
        : (this.phoneNoTextField.valid = !returnValue);
      return returnValue;
    },
     theme () {
        return {
          validColor: { color: this.validColor },
          errorColor: { color: this.errorColor },
          
        }
      }
  },

  mounted() {
    this.fatchData()
    //this.$refs.phoneNoConfirm.focus()
  },

  methods: {
    checkValidation(val){
    let checkVal = JSON.parse(this.result);
    this.submitState = checkVal.isValid;
    this.inputTextVal = val;
    console.log(checkVal.isValid)
    if(checkVal.isValid === true){
      console.log('true=>',checkVal.isValid)
      this.checkDisabled = false
    } else {
      console.log('false=>',checkVal.isValid)
      this.checkDisabled = true
    }
    },
    fatchData() {
          memberApi.getMemberInfo().then((response)=>{
              this.personalInfo = response.data.data
              this.profileImage = this.personalInfo? this.personalInfo.profile:''
              //this.phoneNoConfirm = this.personalInfo? this.personalInfo.phone.phone:''
              
          })
      },
    changePassword() {
      this.$validator.validateAll().then((resultValid) => {
        //this.submitState = true;
        
        let data = JSON.parse(this.result);
        let countryCode = data.countryCallingCode;
        let phoneNo = data.nationalNumber;
        let telNoWithCode =  data.e164;
         
        let resultValids = data.isValid;
        // if(this.submitState === false && this.phoneNoConfirm== ''){
        //   this.inputTextVal = '1'
        //   console.log('hii')
        // }
        // console.log('testtt',resultValids);
        if (resultValids === true) {
          let params = {
            phone:{
              country : countryCode,
              phone : phoneNo,
            }
                //fullPhoneNumber : telNoWithCode
          }
          this.personalInfo.phone = params
          memberApi.addPhoneNo(params).then((response) => {
            console.log('response',response.data.data)
              let responseData = response.data.data
              if (responseData) {
                   this.$router.push('/member/myinfo')
                //   alertParams = {
                //       title: this.$t('325'),
                //       content: this.$t('326'),
                //       accept: this.$t('328'),
                //   }
                //   this.$alert(alertParams).then(() => {
                //       this.$router.push('/myinfo')
                //   })
              } else {
                  //this.$snackOpen({contents:this.$t('Todo-비밀번호 변경에 실패하였습니다. 관리자에게 문의 바랍니다.')}).then(() => {})
              }
          }).catch((err) => {
            console.log(err)
              // responseData = err.response.data.meta
              // this.$snackOpen({contents:this.$t('344'), btnDisplayYN:true, btnDisplay:this.$t('345')}).then(() => {})
          })
        }
      });
    },
    cancel() {
      this.$router.push("myinfo");
    },
  },
};
</script>

<style  scoped>
.input-tel__input{
  height: 50px !important;
  min-height: 50px !important;

}
.country-selector.input-country-selector.has-value {
    height: 80px !important;
}
.input-tel.is-valid .input-tel__input.input-tel.is-valid {
  border-color:#cd3280 !important; 
}

input#MazPhoneNumberInput-26_country_selector {
    height: 50px !important;
    min-height: 50px !important;
}
</style>